import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { IItemsWithSelection } from '../interfaces';
import { SharedModule } from '../shared.module';

@Component({
  standalone: true,
  selector: 'icu-select-item',
  templateUrl: 'select-item.component.html',
  imports: [SharedModule],
  styleUrls: ['select-item.component.css'],
})
export class SelectItemComponent {
  @Input() disabled?: boolean;
  @Input() title?: string;
  @Input() itemsWithSelection!: IItemsWithSelection;
  @Input() displayPropertyName = 'name';

  @Output() selectionChange = new EventEmitter<any>();

  onSelectionChange(args: MatSelectChange): void {
    this.selectionChange.emit(args.value);
  }
}
